module.exports = __webpack_public_path__ + "img/research.4398eb10.png";